import { useState } from 'react';
import '../styles/ContactForm.css';

const ContactForm = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionStatus, setSubmissionStatus] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmissionStatus('');
        // const body = JSON.stringify({
        //     email,
        //     message,
        // });
        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('content', message);

            const response = await fetch('https://myeasydating.com/contactus/submit', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Server error: ${response.statusText}`);
            }

            const data = await response.json();
            if (data.code == 0) {
                setSubmissionStatus('Thank you! Your message has been received.');
            } else {
                setSubmissionStatus(data.message || 'Oops! Something went wrong. Please try again.');
            }
            setEmail('');
            setMessage('');
        } catch (error) {
            console.error(error);
            setSubmissionStatus('Oops! Something went wrong. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleMessageChange = (e) => {
        const newMessage = e.target.value;
        if (newMessage.length <= 256) {
            setMessage(newMessage);
        }
    };

    return (
        <div className="contact-card">
            <h2>Contact Us</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="message">Message:</label>
                    <textarea
                        id="message"
                        name="message"
                        value={message}
                        onChange={handleMessageChange}
                        rows="4"
                        required
                    ></textarea>
                    <div className="char-count">{message.length} / 256</div>
                </div>
                <div className="form-actions">
                    <button type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Requesting...' : 'Submit'}
                    </button>
                </div>
            </form>
            {submissionStatus && (
                <div className="submission-status">
                    {submissionStatus}
                </div>
            )}
        </div>
    );
};

export default ContactForm;
